import React from 'react';

export const BOOKING_STATUSES = ['not booked', 'booked', 'tentative', 'cancelled', 'invoiced'];

export const STATUS_LABELS = {
  'not booked': 'Not Booked',
  'booked': 'Booked',
  'tentative': 'Tentative',
  'cancelled': 'Cancelled',
  'invoiced': 'Invoiced',
};

export const STATUS_BADGE_STYLES = {
  'not booked': 'bg-gray-500/40 text-gray-300',
  'booked': 'bg-green-600/20 text-green-400',
  'tentative': 'bg-amber-500/20 text-amber-300',
  'cancelled': 'bg-red-500/20 text-red-200',
  'invoiced': 'bg-blue-500/20 text-blue-300',
};

const ALIAS_MAP = {
  '': 'not booked',
  'not booked': 'not booked',
  'unbooked': 'not booked',
  'no': 'not booked',
  'booked': 'booked',
  'yes': 'booked',
  'tentative': 'tentative',
  'tent': 'tentative',
  'maybe': 'tentative',
  'cancelled': 'cancelled',
  'canceled': 'cancelled',
  'cancel': 'cancelled',
  'invoiced': 'invoiced',
  'invoice': 'invoiced',
  'billed': 'invoiced',
  'paid': 'invoiced',
  'complete': 'invoiced',
  'completed': 'invoiced',
  'done': 'invoiced',
};

export const normalizeBookingStatus = (raw) => {
  const trimmed = (raw || '').toString().trim().toLowerCase();
  const canonical = ALIAS_MAP[trimmed];
  if (canonical !== undefined) {
    return { canonical, raw: raw || '', isUnknown: false };
  }
  return { canonical: 'booked', raw: raw || '', isUnknown: true };
};

// StatusBadge — renders a colored pill + raw "!" indicator for unknown statuses.
// Pass `hideBooked` to skip rendering for canonical 'booked' (used on route cards
// where most jobs are booked and a green pill on every one is visual noise).
export const StatusBadge = ({ status, hideBooked = false, className = '' }) => {
  const { canonical, raw, isUnknown } = normalizeBookingStatus(status);
  if (hideBooked && canonical === 'booked' && !isUnknown) return null;

  const label = isUnknown && raw ? raw : STATUS_LABELS[canonical];
  const style = STATUS_BADGE_STYLES[canonical];

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className={`text-xs px-1.5 py-0.5 rounded ${style}`}>{label}</span>
      {isUnknown && (
        <span
          title={`Unknown booking status "${raw}" — interpreted as "${STATUS_LABELS[canonical]}"`}
          className="text-xs px-1 py-0.5 rounded bg-red-500/30 text-red-200 font-bold leading-none"
        >
          !
        </span>
      )}
    </span>
  );
};
